import { GetDeviceLogsParams } from '@/api/deviceApi'
import { DeploymentGroupMember } from '@/types/deploymentGroup'

export const GROUP_MESSAGES_ONLY = 'group-messages'

export type AppLogScope =
  | { kind: 'deployment'; deploymentId: string }
  | { kind: 'group'; groupId: string; members: DeploymentGroupMember[] }

type ScopeLogParams = Pick<
  GetDeviceLogsParams,
  'group_id' | 'deployment_id' | 'source_type'
>

export const buildGroupLogParams = (
  groupId: string,
  camera?: string
): ScopeLogParams => {
  if (!camera) {
    return { group_id: groupId }
  }
  if (camera === GROUP_MESSAGES_ONLY) {
    return { group_id: groupId, source_type: 'app_group' }
  }
  return { deployment_id: camera }
}

export const buildScopeLogParams = (
  scope: AppLogScope,
  camera?: string
): ScopeLogParams => {
  if (scope.kind === 'group') {
    return buildGroupLogParams(scope.groupId, camera)
  }
  return { deployment_id: scope.deploymentId, source_type: 'app_deployment' }
}
